require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-does-divestment-by-mdbs-leave-communities-in-the-lurch.json") })
        }
      }, "path---en-us-update-does-divestment-by-mdbs-leave-communities-in-the-lurch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-does-divestment-by-mdbs-leave-communities-in-the-lurch!./.cache/json/en-us-update-does-divestment-by-mdbs-leave-communities-in-the-lurch.json
// module id = 657
// module chunks = 231608221292675